import { PanelLeft, PanelLeftClose, Columns2 } from 'lucide-react'
import { useSidebarStore } from '@/stores/sidebarStore'
import { useLocationAccess } from '@/hooks/useLocationAccess'
import { Island } from './Island'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export function SidebarToggle() {
  const { mainState, railVisible, setMainState, toggleRail, enterFocusMode, exitFocusMode } =
    useSidebarStore()
  const { hasMultipleLocations } = useLocationAccess()

  const isSidebarVisible = mainState !== 'hidden'
  const isAllHidden = mainState === 'hidden' && !railVisible
  return (
    <Island className="absolute left-3 top-3 z-20 p-1">
      <TooltipProvider delayDuration={300}>
        <div className="flex items-center gap-0.5">
          {/* Sidebar toggle */}
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                onClick={() => {
                  if (isAllHidden) {
                    exitFocusMode()
                  } else if (isSidebarVisible) {
                    enterFocusMode()
                  } else {
                    setMainState('expanded')
                  }
                }}
                className={cn(
                  'flex h-8 w-8 items-center justify-center rounded-lg transition-colors',
                  isSidebarVisible
                    ? 'text-muted-foreground hover:bg-accent hover:text-foreground'
                    : 'text-muted-foreground/60 hover:bg-accent hover:text-foreground'
                )}
              >
                {isSidebarVisible ? (
                  <PanelLeftClose className="h-4 w-4" />
                ) : (
                  <PanelLeft className="h-4 w-4" />
                )}
              </button>
            </TooltipTrigger>
            <TooltipContent side="bottom" sideOffset={6}>
              {isSidebarVisible ? 'Hide sidebar' : 'Show sidebar'}
              <kbd className="ml-2 text-[10px] font-mono text-muted-foreground">Ctrl+\</kbd>
            </TooltipContent>
          </Tooltip>

          {/* Rail toggle — only for multi-location users */}
          {hasMultipleLocations && (
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  onClick={toggleRail}
                  className={cn(
                    'flex h-8 w-8 items-center justify-center rounded-lg transition-colors',
                    railVisible
                      ? 'text-muted-foreground hover:bg-accent hover:text-foreground'
                      : 'text-muted-foreground/60 hover:bg-accent hover:text-foreground'
                  )}
                >
                  <Columns2 className="h-4 w-4" />
                </button>
              </TooltipTrigger>
              <TooltipContent side="bottom" sideOffset={6}>
                {railVisible ? 'Hide location rail' : 'Show location rail'}
                <kbd className="ml-2 text-[10px] font-mono text-muted-foreground">Ctrl+[</kbd>
              </TooltipContent>
            </Tooltip>
          )}
        </div>
      </TooltipProvider>
    </Island>
  )
}
